export const isQA = window.location.origin.includes("qa") || window.location.origin.includes("localhost");
export const StageFrontTNOWBrokerId = 1148503;

export const ExportDestination = {
	Cims: 128,
	GameTime: 121,
	GoTickets: 127,
	SeatGeek: 117,
	StubHub: 104,
	TicketsNow: 106,
	ViaGoGo: 120,
} as const;

export const UserRole = {
	CimsAccess: "CIMSMarketAccess",
	StageFront: "StageFront",
	StandardReport: "StandardReport",
	CancelInvoices: "CancelInvoices",
	CancelExternalInvoices: "CancelExternalInvoices",
	EditSeats: "EditSeats",
	ForceEditSeats: "ForceEditSeats",
	Accounting: "Accounting",
	CreateAdjustment: "CreateAdjustment",
	DeleteAdjustment: "DeleteAdjustment",
} as const;

export const INVENTORY_ROW_CLICK_IGNORED_COLUMNS: Array<string> = ["InternalNotes", "ExternalNotes", "Tag"];
export const getUnsoldFirstSortGroup = (row: { Invoice_ID?: unknown }): number => (row.Invoice_ID ? 1 : 0);
